import './SchoolBranchOfficerDetailPage.scss'

import { Button, Col, Form, Input, notification, Row, Select } from 'antd'
import AppContext from 'context/AppContext'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useKampusYetkilisiDetayQuery,
  useKampusYetkilisiEkleMutation,
  useOkulKampusleriQuery,
} from '../../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../../spinner/Spinner'
const SchoolBranchOfficerDetailPage = () => {
  const { id } = useParams()
  const [form] = Form.useForm()
  const { okul } = useContext(AppContext)
  const [selectedKampusler, setSelectedKampusler] = useState<number[]>([])
  const navigate = useNavigate()
  const [kampusYetkilisiEkleMutation] = useKampusYetkilisiEkleMutation()
  const {
    data: kampusData,
    loading: kampusLoading,
    error: kampusError,
  } = useKampusYetkilisiDetayQuery({
    variables: {
      id: parseInt(id ? id : '0'),
    },
    skip: !id, // ID yoksa sorguyu çalıştırma
    fetchPolicy: 'network-only',
  })
  const { data, loading, error } = useOkulKampusleriQuery({
    // <-- refetch ekledik
    variables: {
      sube_id: okul?.id,
    },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (id && kampusData?.kampusYetkilisiDetay) {
      form.setFieldsValue({
        isim: kampusData.kampusYetkilisiDetay.isim || '',
        soyisim: kampusData.kampusYetkilisiDetay.soyisim || '',
        gsm: kampusData.kampusYetkilisiDetay.gsm || '',
        email: kampusData.kampusYetkilisiDetay.email || '',
        sube_ids: kampusData.kampusYetkilisiDetay.kampus?.map((k: any) => k.id) || [],
      })
      setSelectedKampusler(kampusData.kampusYetkilisiDetay.kampus?.map((k: any) => k.id) || [])
    }
  }, [kampusData, form, id])

  if (kampusLoading || loading) {
    return <Spinner color="red" showSpinner={kampusLoading} />
  }

  if (kampusError || error) {
    console.error(kampusError)
    notification.success({
      message: '',
      description: `Bir hata meydana geldi`,
      duration: 6,
    })
  }

  const handleSubmit = async () => {
    const values = await form.validateFields()
    const input = {
      isim: values.isim,
      kampus_yetkilisi_id: parseInt(id ? id : '0'),
      soyisim: values.soyisim,
      sube_ids: selectedKampusler,
      gsm: values.gsm,
      email: values.email,
      sifre: values.password || '',
      sifre_onay: values.passwordConfirm || '',
      ciro_yetkisi: values.ciro_yetkisi || false,
    }

    try {
      const response = await kampusYetkilisiEkleMutation({
        variables: {
          input: {
            isim: input.isim,
            soyisim: input.soyisim,
            sube_ids: input.sube_ids,
            gsm: input.gsm,
            email: input.email,
            sifre: input.sifre,
            sifre_onay: input.sifre_onay,
            ciro_yetkisi: input.ciro_yetkisi,
            kampus_yetkilisi_id: input.kampus_yetkilisi_id,
          },
        },
      })

      if (response.data?.kampusYetkilisiEkle.success) {
        notification.success({
          message: '',
          description: response.data?.kampusYetkilisiEkle?.message,
          duration: 6,
        })
        navigate(-1)
      } else {
        notification.error({
          message: '',
          description: response.data?.kampusYetkilisiEkle?.message || 'Bir hata oluştu',
        })
      }
    } catch {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    }
  }

  return (
    <div className="okul-subeler-detail-page">
      {id ? (
        <>
          <h1>Kampüs Yetkili Detay </h1>
          <Form onFinish={handleSubmit} className="okul-yonetim-detail-form" layout="vertical" form={form}>
            <Row className='user-info-row' gutter={16}>
              <Col className="user-info-col" span={24}>
                <Col span={8}>
                  <Form.Item label="İsim" name="isim" rules={[{ required: true, message: 'Lütfen isim girin!' }]}>
                    <Input placeholder="İsim giriniz" />
                  </Form.Item>
                  <Form.Item
                    label="Soyisim"
                    name="soyisim"
                    rules={[{ required: true, message: 'Lütfen soyisim girin!' }]}
                  >
                    <Input placeholder="Soyisim giriniz" />
                  </Form.Item>
                </Col>
                {/* <Divider type="vertical" /> */}
                <Col span={8}>
                  <Form.Item
                    label="GSM"
                    name="gsm"
                    rules={[
                      {
                        required: true,
                        pattern: /^[1-9]{1}[0-9]{9}$/,
                        message: 'Geçerli bir telefon numarası giriniz!',
                      },
                    ]}
                  >
                    <Input disabled placeholder="Başında 0 olmadan yazınız" />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, type: 'email', message: 'Geçerli bir email girin!' }]}
                  >
                    <Input disabled placeholder="Email giriniz" />
                  </Form.Item>
                </Col>
                {/* <Divider type="vertical" /> */}
                <Col span={8}>
                  <Form.Item
                    label="Şifre"
                    name="password"
                    className="password-input"
                    rules={[
                      { required: !id, message: 'Lütfen şifre girin!' }, // Yalnızca yeni ekleme için zorunlu
                    ]}
                  >
                    <Input.Password disabled placeholder="Şifre giriniz" />
                  </Form.Item>
                  <Form.Item
                    label="Şifre Onayı"
                    name="passwordConfirm"
                    dependencies={['password']}
                    className="password-input"
                    rules={[
                      { required: !id, message: 'Lütfen şifrenizi tekrar giriniz!' }, // Yeni eklemede zorunlu, güncellemede opsiyonel
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value && !id) {
                            return Promise.reject(new Error('Lütfen şifrenizi tekrar giriniz!'))
                          }
                          if (value && getFieldValue('password') !== value) {
                            return Promise.reject(new Error('Şifreler uyuşmuyor!'))
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                  >
                    <Input.Password disabled placeholder="Şifrenizi tekrar giriniz" />
                  </Form.Item>
                </Col>
              </Col>
              <Col span={24} className="user-info-col">
                <Col span={8}>
                  <Form.Item
                    label="Kampüsler"
                    name="sube_ids"
                    rules={[{ required: true, message: 'Lütfen en az bir kampüs seçin!' }]}
                  >
                    <Select
                      mode="multiple"
                      allowClear
                      suffixIcon={null}
                      style={{ width: '100%' }}
                      placeholder="Kampüs seçiniz"
                      value={selectedKampusler} // Seçilen kampüsler state'den alınıyor
                      onChange={(value) => setSelectedKampusler(value)} // Kampüsler değiştikçe güncelleniyor
                      options={data?.okulKampusleri?.kampusler.map((kampus: any) => ({
                        label: kampus.isim,
                        value: kampus.id,
                      }))} // Tüm kampüsler her zaman gösterilecek
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Ciro Yetkisi" name="ciro_yetkisi">
                    <Select
                      suffixIcon={null}
                      defaultValue={kampusData?.kampusYetkilisiDetay?.ciro_yetkisi ? 'Evet' : 'Hayır'}
                      options={[
                        { label: 'Evet', value: true },
                        { label: 'Hayır', value: false },
                      ]}
                    ></Select>
                  </Form.Item>
                </Col>
              </Col>
            </Row>
            <Button className="back-btn" onClick={() => navigate(-1)}>
              Geri
            </Button>
            <Button className="update-btn" htmlType="submit">
              Güncelle
            </Button>
          </Form>
        </>
      ) : (
        <>
          <h1>Kampüs Yetkilisi Ekle </h1>
          <Form onFinish={handleSubmit} className="okul-yonetim-detail-form" layout="vertical" form={form}>
            <Row className="user-info-row" gutter={16}>
              <Col className="user-info-col" span={24}>
                <Col span={8}>
                  <Form.Item label="İsim" name="isim" rules={[{ required: true, message: 'Lütfen isim girin!' }]}>
                    <Input placeholder="İsim giriniz" />
                  </Form.Item>
                  <Form.Item
                    label="Soyisim"
                    name="soyisim"
                    rules={[{ required: true, message: 'Lütfen soyisim girin!' }]}
                  >
                    <Input placeholder="Soyisim giriniz" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="GSM"
                    name="gsm"
                    rules={[
                      {
                        required: true,
                        pattern: /^[1-9]{1}[0-9]{9}$/,
                        message: 'Geçerli bir telefon numarası giriniz!',
                      },
                    ]}
                  >
                    <Input placeholder="Başında 0 olmadan yazınız" />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, type: 'email', message: 'Geçerli bir email girin!' }]}
                  >
                    <Input placeholder="Email giriniz" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Şifre"
                    name="password"
                    className="password-input"
                    rules={[
                      { required: !id, message: 'Lütfen şifre girin!' }, // Yalnızca yeni ekleme için zorunlu
                    ]}
                  >
                    <Input.Password placeholder="Şifre giriniz" />
                  </Form.Item>
                  <Form.Item
                    label="Şifre Onayı"
                    name="passwordConfirm"
                    dependencies={['password']}
                    className="password-input"
                    rules={[
                      { required: !id, message: 'Lütfen şifrenizi tekrar giriniz!' }, // Yeni eklemede zorunlu, güncellemede opsiyonel
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value && !id) {
                            return Promise.reject(new Error('Lütfen şifrenizi tekrar giriniz!'))
                          }
                          if (value && getFieldValue('password') !== value) {
                            return Promise.reject(new Error('Şifreler uyuşmuyor!'))
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                  >
                    <Input.Password placeholder="Şifrenizi tekrar giriniz" />
                  </Form.Item>
                </Col>
              </Col>
              <Col className="user-info-col" span={24}>
                <Col span={8}>
                  <Form.Item
                    label="Kampüsler"
                    name="sube_ids"
                    rules={[{ required: true, message: 'Lütfen en az bir kampüs seçin!' }]}
                  >
                    <Select
                      mode="multiple"
                      allowClear
                      suffixIcon={null}
                      style={{ width: '100%' }}
                      placeholder="Kampüs seçiniz"
                      value={selectedKampusler} // Seçilen kampüsler state'den alınıyor
                      onChange={(value) => setSelectedKampusler(value)} // Kampüsler değiştikçe güncelleniyor
                      options={data?.okulKampusleri?.kampusler.map((kampus: any) => ({
                        label: kampus.isim,
                        value: kampus.id,
                      }))} // Tüm kampüsler her zaman gösterilecek
                    />
                  </Form.Item>
                </Col>
              </Col>
            </Row>
            <Button className="back-btn" onClick={() => navigate(-1)}>
              Geri
            </Button>
            <Button className="update-btn" htmlType="submit">
              Kaydet
            </Button>
          </Form>
        </>
      )}
    </div>
  )
}

export default SchoolBranchOfficerDetailPage
